import React from 'react';
import PropTypes from 'prop-types';
import { SELECTED_MODIFIER } from '../constants';

const Variant = ({ variantId, name, price, selectedVariant, handleVariantSelect, className }) => (
  <button
    key={variantId}
    id={`blaze-ecommerce-variant-button-${variantId}`}
    aria-checked={variantId === selectedVariant}
    className={`${className}__variant${variantId === selectedVariant ? SELECTED_MODIFIER : ''}`}
    type="button"
    role="radio"
    onClick={() => handleVariantSelect(variantId)}>
    <div className={`${className}__variant__content`}>
      <span className={`${className}__variant__content__label`}>{name}</span>
      <span className={`${className}__variant__content__price`}>{price}</span>
    </div>
  </button>
);

Variant.propTypes = {
  variantId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  selectedVariant: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  handleVariantSelect: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired
};

export default Variant;
